import { Box, Column, Columns, IconRenderer, Text } from 'braid-design-system';
import type { ReactNode } from 'react';

import { seekPassAlertContainer } from './SEEKPassAlert.css';

type AlertProps = {
  children: ReactNode;
};

export const SeekPassAlert = ({ children }: AlertProps) => (
  <Box
    paddingY="medium"
    paddingX="gutter"
    borderRadius="large"
    overflow="hidden"
    role="alert"
    aria-live="polite"
    textAlign="left"
    className={seekPassAlertContainer}
  >
    <Columns space="small">
      <Column width="content">
        <Box style={{ marginTop: '0.3em' }}>
          <Text size="large">
            <IconRenderer>
              {({ className }) => (
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 14 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={className}
                >
                  <path
                    d="M7 16C6.881 16 6.769 15.9709 6.657 15.9054L0.357 12.269C0.133 12.1381 0 11.8981 0 11.6363V4.36359C0 4.10177 0.14 3.8545 0.357 3.73086L6.657 0.0944973C6.867 -0.0291391 7.126 -0.0291391 7.336 0.0944973L13.636 3.73086C13.86 3.86177 13.993 4.10177 13.993 4.36359V11.6363C13.993 11.8981 13.853 12.1454 13.636 12.269L7.336 15.9054C7.231 15.9636 7.112 16 6.993 16H7ZM1.4 11.2072L7 14.4436L12.6 11.2072V4.79268L7 1.55632L1.4 4.79268V11.2072Z"
                    fill="#503DC9"
                  />
                  <path
                    d="M6.30001 10.1818C6.11801 10.1818 5.94301 10.1091 5.80301 9.97093L3.90601 8.00002L4.89301 6.97457L6.29301 8.42911L9.09301 5.52002L10.08 6.54547L6.78301 9.97093C6.64301 10.1164 6.46801 10.1818 6.28601 10.1818H6.30001Z"
                    fill="#503DC9"
                  />
                </svg>
              )}
            </IconRenderer>
          </Text>
        </Box>
      </Column>
      <Column>
        <Box>{children}</Box>
      </Column>
    </Columns>
  </Box>
);
